import { render, staticRenderFns } from "./currentAccount.vue?vue&type=template&id=00835122&scoped=true"
import script from "./currentAccount.vue?vue&type=script&lang=js"
export * from "./currentAccount.vue?vue&type=script&lang=js"
import style0 from "./currentAccount.vue?vue&type=style&index=0&id=00835122&prod&lang=css"
import style1 from "./currentAccount.vue?vue&type=style&index=1&id=00835122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00835122",
  null
  
)

export default component.exports